import { render, staticRenderFns } from "./ExtraClassTab.vue?vue&type=template&id=7c96db43"
import script from "./ExtraClassTab.vue?vue&type=script&lang=js"
export * from "./ExtraClassTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports